(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItCategories', ["path", "securityEventsDao", "timeResolutions", "defaultChartColorList", "routeHelper", function (path, securityEventsDao, timeResolutions, defaultChartColorList, routeHelper) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/categories').template('categories'),
            scope: {
                saasList: '=',
                resolution: '=',
                eventStates: '='
            },
            link: function ($scope, element) {
                function initializeModel() {
                    if ($scope.model) {
                        return;
                    }
                    $scope.model = {
                        flotOptions: {
                            series: {
                                pie: {
                                    show: true,
                                    highlight: { opacity: 0.2 },
                                    innerRadius: 30,
                                    radius: 45,
                                    stroke: { width: 0 }
                                }
                            },
                            colors: defaultChartColorList,
                            grid: {
                                hoverable: true,
                                clickable: true
                            },
                            legend: {
                                labelFormatter: function (label, series) {
                                    return label;
                                },
                                container: element.find('.chart-legend')
                            },
                            tooltip: true,
                            tooltipOpts: {
                                defaultTheme: false,
                                content: '%s',
                                shifts: {
                                    x: 0,
                                    y: 20
                                },
                                cssClass: 'pieChartTip',
                                disableCentering: true
                            }
                        },
                        watchFlotOptions: false
                    };
                    $scope.initialized = true;
                }
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    var resolution = timeResolutions.get($scope.resolution);
                    var q = securityEventsDao.list().params({
                        groupBy: 'av_category',
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_type: 'shadow_it',
                        afterColumn: 'create_time',
                        afterStep: resolution.id,
                        afterFromNow: true,
                        afterMax: 1
                    });
                    var linkParams = {
                        resolution: resolution.id,
                        saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(',')
                    };
                    if ($scope.eventStates) {
                        q = q.params({ filterEnum_current_state: $scope.eventStates.join(',') });
                        linkParams.states = $scope.eventStates.join(',');
                    }
                    return q.order('count', 'desc').then(function (response) {
                        initializeModel();
                        $scope.model.data = _(response.data.rows).map(function (row) {
                            var linkPath = routeHelper.getPath('shadow-it-apps', {}, $.extend({ category: row.av_category }, linkParams));
                            return {
                                label: '<a href="' + routeHelper.pathToHref(linkPath) + '" class="legend-line">' + '<div class="legend-label">' + row.av_category + '</div>' + '<div class="legend-count">' + row.count + '</div>' + '</a>',
                                data: row.count,
                                link: linkPath
                            };
                        });
                    });
                };
                $scope.$watchGroup([
                    'resolution',
                    'saasList',
                    'eventStates'
                ], function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());